import { render, staticRenderFns } from "./countdownForH5.vue?vue&type=template&id=3ef6e4ba&scoped=true&"
import script from "./countdownForH5.vue?vue&type=script&lang=js&"
export * from "./countdownForH5.vue?vue&type=script&lang=js&"
import style0 from "./countdownForH5.vue?vue&type=style&index=0&id=3ef6e4ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef6e4ba",
  null
  
)

export default component.exports